export default {
	appContext: {
		application: 'gkcl',
		redirectUri: window.location.origin,
		scope: 'kcl',
	},
	urls: {
		codelistContext: 'code-table',
	},
};
